import { createAsyncThunk } from '@reduxjs/toolkit';
import SavedPostsAPI from './savedPostsAPI';

export const fetchMySavedPostIdsThunk = createAsyncThunk(
  'savedPosts/fetchMine',
  async (_, { rejectWithValue }) => {
    try {
      return await SavedPostsAPI.getMine();
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const savePostThunk = createAsyncThunk(
  'savedPosts/save',
  async ({ postId, groupPostId }, { rejectWithValue }) => {
    try {
      await SavedPostsAPI.save({ postId, groupPostId });
      return { postId, groupPostId };
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const unsavePostThunk = createAsyncThunk(
  'savedPosts/unsave',
  async ({ postId, groupPostId }, { rejectWithValue }) => {
    try {
      await SavedPostsAPI.unsave({ postId, groupPostId });
      return { postId, groupPostId };
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);
